import RelatedCategories from './RelatedCategories'

export default RelatedCategories
